import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { useForm } from "react-hook-form";
import * as z from "zod";

import { HTTPErrorCallback } from "Helpers/Error";
import { getPasswordSecurityVerifications } from "Helpers/Password";

import { UseGlobalLoading } from "Hooks/UseGlobalLoading";
import UseNotification from "Hooks/UseNotification";
import UseServices from "Hooks/UseServices";

import Button from "Components/Admin/Buttons";
import FormWrapper from "Components/Admin/Form/FormWrapper";
import Input from "Components/Admin/Form/Input";
import Section from "Components/Admin/Section";

import * as S from "../../styles";

const CreateAdmin = () => {
  const { api } = UseServices();
  const { showNotification } = UseNotification();
  const { loading, setLoading } = UseGlobalLoading(false);

  const [password, setPassword] = useState("");

  const formSchema = z.object({
    full_name: z.string({ message: "Campo obrigatório" }).min(3, {
      message: "Nome muito curto",
    }),
    email: z.string().email({ message: "E-mail inválido" }),
  });

  const methods = useForm({
    resolver: zodResolver(formSchema),
  });
  const { register, reset } = methods;

  const showError = (message) => {
    showNotification("danger", "Atenção!", message);
  };

  const submit = (data) => {
    setLoading(true);

    const verifications = getPasswordSecurityVerifications(
      password,
      null,
      false,
    );

    if (
      !verifications.hasEnoughLength ||
      !verifications.hasNumber ||
      !verifications.hasUppercase ||
      !verifications.hasSpecialCharacters
    ) {
      setLoading(false);
      return showError(
        "A senha não atende aos requisitos mínimos de segurança!",
      );
    }

    api
      .post("/users/create-admin-user", {
        ...data,
        password,
      })
      .then(() => {
        setLoading(false);

        showNotification("success", "Sucesso!", "Usuário criado com sucesso!");
        setPassword("");
        reset();
      })
      .catch((error) => {
        setLoading(false);
        return HTTPErrorCallback(error);
      });
  };

  return (
    <Section>
      <S.Wrapper>
        <FormWrapper submit={submit} {...methods}>
          <Input
            {...register("full_name")}
            label="Nome Completo"
            placeholder="Nome"
            type="text"
            required
          />
          <Input
            {...register("email")}
            type="email"
            label="E-mail"
            placeholder="E-mail"
            required
          />
          <Input
            name="password"
            type="password"
            label="Senha"
            placeholder="Senha"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button type="submit" text="Criar" disabled={loading} />
          <S.InfoText>
            Nenhum e-mail é enviado ao usuário. Informe manualmente as
            credenciais de acesso.
          </S.InfoText>
        </FormWrapper>
      </S.Wrapper>
    </Section>
  );
};

export default CreateAdmin;
